module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture11-9751170df083d129015061363f0997e6.jpg";